import { useEffect, useRef } from 'react';

import { subscribeServerEvent } from '../lib/server-events';

/**
 * Nghe MỘT tên event trên SSE stream dùng chung (`GET /api/v1/events`).
 *
 * Callback giữ trong `useRef` để đổi handler không phải đăng ký lại. Nhiều hook
 * cùng dùng chung một connection (xem {@link subscribeServerEvent}).
 *
 * @param eventName tên event SSE (`sync-completed`, `jackpot`, …).
 * @param onEvent nhận `data` thô (chuỗi) — caller tự parse.
 * @param enabled false thì không đăng ký (vd chưa đăng nhập).
 */
export function useServerEvent(
  eventName: string,
  onEvent: (data: string) => void,
  enabled = true,
): void {
  const cbRef = useRef(onEvent);
  cbRef.current = onEvent;

  useEffect(() => {
    if (!enabled) return;
    return subscribeServerEvent(eventName, (data) => cbRef.current(data));
  }, [eventName, enabled]);
}
